import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'ionic-appflow',
    loadComponent: () =>
      import(
        './components/compare-ionic-appflow/compare-ionic-appflow.component'
      ).then(m => m.CompareIonicAppflowComponent),
  },
  {
    path: 'capgo',
    loadComponent: () =>
      import('./components/compare-capgo/compare-capgo.component').then(
        m => m.CompareCapgoComponent,
      ),
  },
  {
    path: '**',
    loadChildren: () => import('../not-found/routes').then(m => m.routes),
  },
];
